import NewProfileComponent from '../../components/NewProfile/NewProfileComponent';
export const ProfilePage = () => {
	return <NewProfileComponent />;
};
